module.exports = __webpack_public_path__ + "assets/img/gaierqi.f28761b6.png";